module.exports = __webpack_public_path__ + "img/how-to-buy-image.ad78f169.png";